import React, { Component } from "react";
import { TableDefault, LabelString } from "@loanbossinc/component-library";
import { findHedgeValue, findWatchHedgeCost } from "./activeLoanHedges.filters";
import styled from "styled-components";
import { StyledRateOrStrike, StyledCost } from "./StyledDataTableHelper";


const StyledTableDefault = styled(TableDefault)`
&& {
    border-bottom: #DADCE0 1px solid;
    border-radius: 0px;
}
`;

export class WatchHedgeDataTable extends Component {
    watchHedgeCols = () => {
        return [
            {
                id: 'hedgeName'
                , label: 'MONITORED HEDGES'
                , path: 'hedgeName'
                , Cell: (value) => <LabelString style={{ color: "#000", fontWeight: "500", width: "100px" }} value={value} />
            }
            , {
                id: 'rateOrStrike'
                , label: 'RATE/STRIKE'
                , path: 'rateOrStrike'
                , Cell: (value) => (<StyledRateOrStrike value={value} />)
            }
            , {
                id: 'term'
                , label: 'TERM'
                , path: 'term'
                , Cell: (value) => <LabelString value={value} />
            }
            , {
                id: 'cost'
                , label: 'COST'
                , path: 'cost'
                , align: 'right'
                , Cell: (value) => (<StyledCost value={value} />)
            }
        ]
    }

    getColumnData = () => {
        const { watchHedges } = this.props;
        return watchHedges.reduce((acc, cur) => {
            acc.push({
                hedgeId: cur.id
                , dealId: cur.dealId
                , hedgeName: `${cur.hedgeProvider ? cur.hedgeProvider.name : cur.hedgeStatus ? cur.hedgeStatus.value : ""} - ${cur.hedgeType ? cur.hedgeType.value : ""}`
                , rateOrStrike: findHedgeValue(cur)
                , term: cur.term ? `${cur.term} mo` : null
                , cost: findWatchHedgeCost(cur)
            })
            return acc;
        }, []);
    }

    render() {
        return (
            <StyledTableDefault
                elevation={0}
                columns={this.watchHedgeCols()}
                items={this.getColumnData()}
                onRowClick={hedge => this.props.history.push(`/hedges/${hedge.hedgeId}`)} />
        )
    }

}